import api from "@helpers/api";

import { URLS } from "@constants/urls";
import { RetirementType } from "@type/HRM/retirement";

const { RETIREMENTS } = URLS;

const apiEndPoint = `${process.env.REACT_APP_RETIREMENT_SERVICE_URL}${process.env.REACT_APP_RETIREMENT_SERVICE_PORT}/${process.env.REACT_APP_RETIREMENT_SERVICE}/api/${process.env.REACT_APP_API_VERSION}/${process.env.REACT_APP_API_PRIVATE}/${RETIREMENTS}`;

export const getRetirement = (() => {
  return async (data: any): Promise<{ data: RetirementType }> => {
    const { retirementID } = data;

    return api.get(`${apiEndPoint}/${retirementID}`).then((response) => {
      return response.data;
    });
  };
})();

export const createRetirement = (() => {
  return async (data: any): Promise<{ data: RetirementType }> => {
    const {
      employeeMasterId,
      unitPositionId,
      retirementDate,
      retirementDetailsEmpDocuments,
      retirementDetailsHrDocuments,
      letter,
    } = data.data;
    return api
      .post(apiEndPoint, {
        letter,
        employeeMasterId: Number(employeeMasterId),
        unitPositionId,
        retirementDate,
        retirementDetailsEmpDocuments,
        retirementDetailsHrDocuments,
      })
      .then((response) => {
        return { data: response.data };
      });
  };
})();
